export default __webpack_public_path__ + "static/media/141.d583f747.gif";